/* eslint-disable no-param-reassign */
import Phaser from 'phaser';
import ABCyaPhaser, { Images as ABCyaImages, Tweens as ABCyaTweens, Text as ABCyaText, Audio as ABCyaAudio, Storage as ABCyaStorage } from '@abcya/abcya_phaser';
import UIAssetKeys from '../UIAssetKeys';
import { positionObject } from '../utils/Builder';
import FontKeys from '../FontKeys';
import SoundAssetKeys from '../SoundAssetKeys';
import SelectLevelScreen from './SelectLevelScreen';
import gameData from '../gameData';
import ABCyaLib from '@abcya/abcya_lib';

export default class IntroScreen extends Phaser.Scene {
  static get KEY() { return 'IntroScreen'; }

  create() {
    const back = ABCyaImages.addImage(0, 0, UIAssetKeys._Bckg, this).setOrigin(0);

    const topBar = ABCyaImages.addImage(0, -334, 'UIBarTop', this).setOrigin(0);
    const bottomBar = ABCyaImages.addImage(0, 368, 'UIBarBottom', this).setOrigin(0);

    const title = ABCyaImages.addImage(85, -140, 'Logo', this, ABCyaPhaser.Images.LOCALIZATION_ATLAS).setOrigin(0);
    title.setScale(0.85);

    const adjustY = 130;
    const blob1 = ABCyaImages.addImage(-250, -120 + adjustY, 'TitleBlob1', this).setOrigin(0);
    const blob2 = ABCyaImages.addImage(-250, 120 + adjustY, 'TitleBlob2', this).setOrigin(0);
    const blob3 = ABCyaImages.addImage(250, -120 + adjustY, 'TitleBlob3', this).setOrigin(0);
    const blob4 = ABCyaImages.addImage(250, 120 + adjustY, 'TitleBlob4', this).setOrigin(0);

    const titleArray = [topBar, bottomBar, title, blob1, blob2, blob3, blob4];
    const titleContainer = this.add.container();
    titleContainer.add(titleArray);

    titleArray.forEach(titleElement => positionObject(titleElement));

    const button = ABCyaImages.addImage(this.scale.width / 2, this.scale.height / 2 - adjustY, 'PlayBtn', titleContainer).setOrigin(0);
    positionObject(button, 0, 0 + adjustY, true);

    this.centerRegPointsMove(button);
    this.centerRegPointsMove(blob1);
    this.centerRegPointsMove(blob2);
    this.centerRegPointsMove(blob3);
    this.centerRegPointsMove(blob4);

    ABCyaTweens.addTween(blob1, 1500, { scaleX: 1.5, scaleY: 0.5, yoyo: true, loop: -1 }, Phaser.Math.Easing.Linear);
    ABCyaTweens.addTween(blob2, 3000, { angle: 360, yoyo: true, loop: -1 }, Phaser.Math.Easing.Linear);
    ABCyaTweens.addTween(blob3, 800, { scaleX: 0.75, scaleY: 0.75, yoyo: true, loop: -1 }, Phaser.Math.Easing.Linear);
    ABCyaTweens.addTween(blob4, 700, { scaleX: 1.5, scaleY: 0.5, yoyo: true, loop: -1 }, Phaser.Math.Easing.Linear);

    const credits = ABCyaText.addText(500, 680, '18pt', 0xE927FF, FontKeys._linotte_heavy, ABCyaPhaser.Localization.instance.getLocalizedString('puzzle_credit'), this).setWordWrapWidth(340);

    if (this.sound.bg === undefined) {
      this.sound.bg = ABCyaAudio.createSound(this, 1, true, 0);
      this.sound.bg.play(SoundAssetKeys._Blobble_Jingle, { loop: true });
    }

    button.setInteractive();
    button.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => {
      ABCyaAudio.playOneShot(SoundAssetKeys._click, this);
      ABCyaTweens.addTween(button, 200, { scaleX: 1.5, scaleY: 0.5, yoyo: true, easeParams: [1, 0.3] }, Phaser.Math.Easing.Bounce.Out, () => {
        horizontalScreenTransisition(this, SelectLevelScreen.KEY);
      });
    });

    const globals = ABCyaLib.Storage.getObject(gameData.storageKey);

    if (globals !== undefined && globals !== null) {
      gameData.LEVELS_CLEARED = globals;
    }
  };

  centerRegPointsMove(container) {

    container.setOrigin(0.5);

    container.x += container.getBounds().width / 2;
    container.y += container.getBounds().height / 2;

  }
}

/**
 * 
 * @param {Phaser.Scene} currentScene 
 * @param {String} nextSceneKey 
 * @param {Boolean} rightToLeft 
 */

export function horizontalScreenTransisition(currentScene, nextSceneKey, rightToLeft = true) {
  let startX; let endX;
  const screenWidth = currentScene.scale.width;
  const duration = 800;
  if (rightToLeft) {
    startX = screenWidth;
    endX = -screenWidth;
  }
  else {
    startX = -screenWidth;
    endX = screenWidth;
  }

  const stopInteract = currentScene.add.rectangle(0, 0, currentScene.scale.width, currentScene.scale.height).setOrigin(0);
  stopInteract.setInteractive();

  currentScene.scene.run(nextSceneKey, {});
  currentScene.scene.sendToBack(nextSceneKey);
  currentScene.scene.wake();
  const sceneRef = currentScene.scene.get(nextSceneKey);

  sceneRef.events.once('start', () => {
    const currentCamera = currentScene.cameras.main;
    const nextCamera = sceneRef.cameras.main;

    nextCamera.setPosition(startX, 0);

    // Does not use ABCYA package Tweens.addTween to maintain grainular control of parent of tween

    if (!currentCamera || !nextCamera)console.log(currentCamera, nextCamera, currentScene, nextSceneKey);

    currentScene.tweens.add({
      targets: currentCamera,
      x: endX,
      duration,
      ease: Phaser.Math.Easing.Linear
    });

    currentScene.tweens.add({
      targets: nextCamera,
      x: 0,
      duration,
      ease: Phaser.Math.Easing.Linear,
      onComplete: () => {
        currentScene.scene.stop(currentScene.scene.key);
      }
    });
  });
}
